export default "__VITE_ASSET__6bsK27Hz__"